import { observer } from "mobx-react";
import * as React from "react";

import { ListVehicleGroups } from "../ui/molecules/list-vehicle-groups";
import { ListCommandButtonsVehicleGroups } from "../ui/organisms/list-command-buttons-vehicle-groups";
import { createUuid } from "../utils/uuid";
import { Section } from "../ui/atoms/section";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageVehicleGroups extends React.Component {
    // Create the UUID on this level, so the button bar is able to access the same state as the list.
    private listStateId = createUuid();

    public render(): JSX.Element {
        return (
            <FusionLayout breadcrumb={store.i18n.t("page.vehicleGroups.title")} classic>
                <Section fill>
                    <ListVehicleGroups
                        commandBar={
                            <ListCommandButtonsVehicleGroups
                                listStateId={this.listStateId}
                                canDelete
                            />
                        }
                        listStateId={this.listStateId}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
